module.exports = __webpack_public_path__ + "img/gallery-24.35907ac8.jpg";